var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"Heading3"},[_vm._v(" テーマ：監査役就任一年目を振り返って－新任の皆様へのメッセージも込めて－（h3) ")])}
var staticRenderFns = []

export { render, staticRenderFns }